interface State {
  navigatedFrom: string
}
let settingsState: Ref<State>

function defaultState() {
  return {
    navigatedFrom: "/home",
  }
}
function clearSettingsState() {
  settingsState.value = defaultState()
}
function openSettings(navigatedFrom?: string) {
  const { switchMainView } = useMainView()

  if (navigatedFrom)
    settingsState.value.navigatedFrom = navigatedFrom
  else
    settingsState.value.navigatedFrom = "/home"

  switchMainView("settings")
}

function exitSettings() {
  navigateTo(settingsState.value.navigatedFrom)
}

export default function () {
  settingsState = useState("settings-state", defaultState)
  return {
    clearSettingsState,
    openSettings,
    exitSettings,
  }
}
